const STRIPE_DASHBOARD_URL = `https://dashboard.stripe.com`;

export function getProductBillingLinkUrl(isTestMode: boolean, billingId: string) {
  return `${STRIPE_DASHBOARD_URL}/${isTestMode ? 'test/' : ''}products/${billingId}`;
}

export function getCustomerBillingLinkUrl(isTestMode: boolean, billingId: string) {
  return `${STRIPE_DASHBOARD_URL}/${isTestMode ? 'test/' : ''}customers/${billingId}`;
}
